import { getAxiosInstance } from "@/axiosClient";

class UserAccessService {
  get axios() {
    return getAxiosInstance();
  }
  async fetchAccessibleClients() {
    const response = await this.axios.get("/api/user-access/clients");
    return response;
  }
  async fetchUserPermissions() {
    const response = await this.axios.get(`/api/user-access/permissions`);
    return response;
  }
  async switchToClient(id) {
    const response = await this.axios.post(
      `/api/user-access/clients/${id}/select`,
    );
    return response;
  }
}

export default new UserAccessService();
